export const RESET_STORE = "RESET_STORE";
export const UPDATE_USER_PROFILE_DATA = "UPDATE_USER_PROFILE_DATA";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const SET_BADGES = "SET_BADGES";
export const UPDATE_USER_TYPE = "UPDATE_USER_TYPE";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
